import React, { useState } from 'react';
import BrandLogo from './BrandLogo';
import SalonForm from '../components/Form/TuMesaYaForm';
import { FormData } from '../types';
import { submitLeadToWebhook } from '../utils/api';
import { useTracking } from '../hooks/useTracking';

type SubmitState = 'idle' | 'success' | 'error';

const TrialPage: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitState, setSubmitState] = useState<SubmitState>('idle');
  const { trackPageView } = useTracking();

  React.useEffect(() => {
    trackPageView('tusalonya-prueba-30-min', 'telemarketing');
  }, [trackPageView]);

  const handleSubmit = async (formData: FormData) => {
    setIsSubmitting(true);
    setSubmitState('idle');

    const response = await submitLeadToWebhook({
      ...formData,
      salon: formData.restaurant,
      brand: 'Peluqueria.AI',
      vertical: 'hair-beauty',
      source: 'tusalonya-telemarketing-trial-30min',
      timestamp: new Date().toISOString(),
    });

    setIsSubmitting(false);
    setSubmitState(response.success ? 'success' : 'error');
    return response.success;
  };

  return (
    <main className="salon-trial-page">
      <header className="salon-trial-header">
        <a href="/">
          <BrandLogo inverse />
        </a>
        <span>Prueba guiada · 30 min</span>
      </header>
      <section className="salon-trial-layout">
        <div className="salon-trial-copy">
          <span className="salon-kicker">
            <i /> Acceso a prueba
          </span>
          <h1>Prueba una agenda que responde mientras tú trabajas.</h1>
          <p>
            Regístrate para experimentar durante 30 minutos cómo Peluqueria.AI
            atiende las llamadas. La atención por WhatsApp llegará
            próximamente y todavía no forma parte de la prueba.
          </p>
          <div className="trial-ticker">
            <span>CORTE</span>
            <b>✦</b>
            <span>COLOR</span>
            <b>✦</b>
            <span>BARBA</span>
            <b>✦</b>
            <span>TRATAMIENTOS</span>
          </div>
        </div>
        <div className="salon-trial-form">
          {submitState === 'success' ? (
            <div className="salon-form-success" role="status">
              <span>✓</span>
              <h2>Registro completado.</h2>
              <p>Te contactaremos para activar la prueba.</p>
            </div>
          ) : (
            <>
              <small>Registro para la prueba</small>
              <h2>Empezamos por vuestro negocio.</h2>
              <SalonForm
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                variant="trial"
                compact
                submitLabel="Activar mi prueba"
              />
              {submitState === 'error' && (
                <p className="salon-form-error" role="alert">
                  No hemos podido completar el registro. Inténtalo de nuevo.
                </p>
              )}
            </>
          )}
        </div>
      </section>
      <footer className="salon-trial-footer">
        <a href="/politica-privacidad">Política de privacidad</a>
        <a href="/aviso-legal">Aviso legal</a>
        <a href="/terminos">Términos y condiciones</a>
        <a href="/cookies">Política de cookies</a>
        <button type="button" data-cc="show-preferencesModal">
          Configurar cookies
        </button>
      </footer>
    </main>
  );
};

export default TrialPage;
